export const planTypeDropdown = () => [
    { id: 1, description: 'Major Medical' },
    { id: 2, description: 'Limited Medical' },
    { id: 3, description: 'Ancillary'}
];